export const config = { snapThreshold: 50 }
